export const tableFrCATranslations = {
  editMode: "Mode d'édition :",
  emptyTableMessage: "Rien à voir ici… pour l'instant !",
  columns: "Colonnes",
  toggleColumnVisibility: "Basculer la visibilité des colonnes",
  filterTable: "Filtrer le tableau",
  filterClear: "Effacer",
  textOperatorIs: "est",
  textOperatorIsNot: "n'est pas",
  textOperatorIsAnyOf: "est l'un de",
  textOperatorIsNotAnyOf: "n'est aucun de",
  dateOperatorEq: "Est exactement",
  dateOperatorGt: "Est après",
  dateOperatorGte: "Est le ou après",
  dateOperatorLt: "Est avant",
  dateOperatorLte: "Est le ou avant",
  numericOperatorEq: "Est égal à",
  numericOperatorGt: "Est supérieur à",
  numericOperatorGte: "Est supérieur ou égal à",
  numericOperatorLt: "Est inférieur à",
  numericOperatorLte: "Est inférieur ou égal à",
  booleanYes: "Oui",
  booleanNo: "Non",
  compoundFilter: "Filtre composé",
  compoundFilterAnd: "Filtre composé (ET)",
  compoundFilterOr: "Filtre composé (OU)",
  paginationItem: "élément",
  paginationItems: "éléments",
};
